import base64 from 'base-64';

export const EncodeData = (data:string) => {
    return base64.encode(data);
}

export const DecodeData = (data:string) => {
    return base64.decode(data);
}